import React, { useState, useEffect } from 'react';
import './Globals.css';
import './StyleGuide.css';
import './EatsureKnowMore.css';
import { Navigate } from 'react-router-dom';
import BG2 from './knowMoreImages/secondCard.png';
import BG4 from './knowMoreImages/forthCard.png';

export default function EatsureKnowMore() {
	var btn = document.getElementById('tap-button');
	var ripple = document.getElementById('ripple');
	btn?.addEventListener('click', clicked);

	const [redirect, setredirect] = useState(false);
	const [width, setwidth] = useState();
	const [transition, settransition] = useState();

	function clicked(e) {
		e.preventDefault();
		if (btn.classList.contains('clicked')) {
			btn.classList.remove('clicked'); //, "animate__animated", "animate__pulse");
			// btn.classList.add("animate__animated","animate__bounceIn");
			ripple.classList.remove('clicked');
		} else {
			btn.classList.add('clicked'); //, "animate__animated", "animate__pulse");
			// btn.classList.remove("animate__animated","animate__bounceIn");
			ripple.classList.add('clicked');
			setTimeout(() => {
				btn.style.transform = 'scale(1.03)';
				// document.querySelector('.text-33').style.transform = 'scale(1.15)';
			}, 500);
		}
	}

	useEffect(() => {
		setTimeout(() => {
			setwidth('239px');
			settransition('all 5s ease');
		}, 1000);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setredirect(true);
		}, 6000);
	}, []);

	return (
		<>
			{redirect ? <Navigate to='/' /> : null}
			<div className='container-center-horizontal'>
				<div className='eatsure-know-more screen'>
					<div className='overlap-group7'>
						<div className='group-6286'>
							<a href='idle-screen.html'>
								<div className='overlap-group'>
									<div className='rectangle-2620'></div>
									<img className='group-27615' src='images/group-27615@1x.png' />
								</div>
							</a>
							<div className='group-5766'>
								<div className='rectangle-2444'></div>
								<div className='rectangle-244'></div>
								<div className='rectangle-244'></div>
							</div>
						</div>
						<img className='rectangle-2012' src='images/rectangle-2012-3@1x.png' />
						<div className='group'>
							<div className='overlap-group1'>
								<img className='group-1' src='images/group@2x.png' />
								<img className='group-2' src='images/Eat sure.png' />
							</div>
							<div className='text-27 valign-text-middle'>
								The Ultimate Foodcourt
							</div>
						</div>
						<div className='overlap-group2'>
							<div className='rectangle-3646'></div>
							<img className='x1352415610' src='images/-1352415610@1x.png' />
							<div className='overlap-group-1'>
								<div className='rectangle-3647'></div>
								<div className='text-28 valign-text-middle blinker-semi-bold-ocean-blue-pearl-41-4px'>
									No Artificial Colours or Flavours
								</div>
							</div>
							<div className='no-artifical-colours'>
								<div className='overlap-group1-1'>
									<img className='group-27589' src='images/group-27589@2x.png' />
									<div className='ellipse-701'></div>
									<img className='vector-11337' src='images/vector-11337@2x.png' />
									<img src='images/No-artifical-colours.png' alt='' />
								</div>
							</div>
						</div>
						<div className='overlap-group3'>
							<img className='x1352415610' src={BG2} />
							<div className='group-27621'>
								<div className='overlap-group1-2'>
									<div className='overlap-group-2'>
										<div className='rectangle-3647-1'></div>
										<div className='text-29 valign-text-middle blinker-semi-bold-ocean-blue-pearl-41-4px'>
											Double-Sealed Packaging
										</div>
									</div>
									<img className='packaging' src='images/packaging@2x.png' />
								</div>
							</div>
						</div>
						<div className='overlap-group4'>
							<img
								className='rectangle-3646-1'
								src='images/rectangle-3646@2x.png'
							/>
							<div className='overlap-group-3'>
								<div className='rectangle-3647-2'></div>
								<div className='text-30 valign-text-middle blinker-semi-bold-ocean-blue-pearl-41-4px'>
									Medically certified <br />
									Kitchen Staff
								</div>
							</div>
							<img className='medical' src='images/medical@2x.png' />
						</div>
						<div className='overlap-group5'>
							<img className='x1352415610' src={BG4} />
							<div className='overlap-group1-3'>
								<div className='overlap-group-4'>
									<div className='rectangle-3647'></div>
									<div className='text-31 valign-text-middle blinker-semi-bold-ocean-blue-pearl-41-4px'>
										200+ Stringent
										<br />
										Quality Checks
									</div>
								</div>
							</div>
							<div className='overlap-group2-1'>
								<div className='group-27224'></div>
								<img className='quality-check' src='images/quality-check@2x.png' />
							</div>
						</div>
						<div className='overlap-group6'>
							<div className='text-32'>WE ACCEPT ALL TYPES OF PAYMENT MODES</div>
							<a href=''>
								<div id='tap-button' className='component-7 border-1-7px-tea-green'>
									<div id='ripple'></div>
									<div className='text-33 blinker-semi-bold-white-72px'>
										Tap To Order
									</div>
								</div>
							</a>
						</div>
						<div className='text-34 blinker-semi-bold-mine-shaft-48px'>
							100% Safe and Secure Payment Transactions
						</div>
						<div className='text-35 blinker-normal-granite-gray-32px'>
							UPI Scan&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Debit &amp; Credit
							Card&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Cash at Counter&nbsp; &nbsp;
							&nbsp; &nbsp; &nbsp; Meal Card
						</div>
						<div className='flex-row'>
							<div className='progress-bar-outer' id='progress-bar-1'>
								<div className='progress-bar-inner' id='inner-progress-1'></div>
							</div>
							<div className='progress-bar-outer' id='progress-bar-2'>
								<div className='progress-bar-inner' id='inner-progress-2'></div>
							</div>
							<div className='progress-bar-outer' id='progress-bar-3'>
								<div className='progress-bar-inner' id='inner-progress-3'></div>
							</div>
							<div className='progress-bar-outer' id='progress-bar-4'>
								<div
									style={{ width: width, transition: transition }}
									className='progress-bar-inner'
									id='inner-progress-4'></div>
							</div>
						</div>
						<img className='scan' src='images/scan@1x.png' />
						<img className='meal-card' src='images/meal-card@1x.png' />
						<img className='cash-at-counter' src='images/cash-at-counter@1x.png' />
						<img
							className='card'
							style={{ border: 'none' }}
							src='images/card@1x.png'
						/>
					</div>
				</div>
			</div>
		</>
	);
}
